import { Link } from 'react-router-dom'

import { AuthScreenLayout } from '../components/auth/AuthScreenLayout'
import {
  MARKETING_CONSENT_EXTERNAL_URL,
  PRIVACY_POLICY_EXTERNAL_URL,
  PUBLIC_OFFER_DOCUMENT_VERSION,
  PUBLIC_OFFER_EXTERNAL_URL,
} from '../legal/publicOffer'

export const PublicOfferLegalScreen = () => (
  <AuthScreenLayout variant="register">
    <article className="market-auth__card market-auth__card--register market-legal-doc">
      <header className="market-auth__card-header market-auth__card-header--compact">
        <h1 className="market-auth__card-title market-auth__card-title--compact">
          Публичная оферта (сублицензионный договор-оферта)
        </h1>
        <p className="market-auth__card-lead market-auth__card-lead--compact">
          Версия {PUBLIC_OFFER_DOCUMENT_VERSION}. Каноническая страница:{' '}
          <a href={PUBLIC_OFFER_EXTERNAL_URL} target="_blank" rel="noreferrer">
            provisium.ru/offer
          </a>
        </p>
      </header>

      <div className="market-legal-doc__body">
        <p className="market-legal-doc__draft" role="note">
          <strong>Черновик v0.</strong> Текст подготовлен для продукта и требует юридической проверки перед
          публикацией как обязательной редакции. Не является утверждённой офертой до ревью юриста.
        </p>

        <h2>1. Термины</h2>
        <p>
          <strong>Сервис</strong> — программный комплекс «Провизиум» / Provisium, предоставляемый как SaaS
          (кабинет market.provisium.ru и связанные API). <strong>Тариф</strong> — пакет лимитов и цены
          (Старт / Месяц / Год). <strong>Учётная запись</strong> — доступ пользователя к кабинету.
          <strong> Расчётный период</strong> — месяц или год по выбранному тарифу.
        </p>

        <h2>2. Стороны</h2>
        <p>
          Исполнитель (Лицензиат по отношению к правообладателю ПО): Индивидуальный предприниматель Новоселов
          Федор Владимирович (ИП Новоселов Ф.В.), ИНН 110119365449, ОГРНИП 318112100016230, адрес: 614095,
          г. Пермь, ул. Карпинского, д. 65, кв. 228, e-mail: support@provisium.ru.
        </p>
        <p>
          Заказчик: юридическое лицо, акцептовавшее оферту.
        </p>

        <h2>3. Предмет</h2>
        <p>
          Исполнитель предоставляет Заказчику доступ к Сервису на условиях простой (неисключительной)
          сублицензии / лицензии конечного пользователя в пределах прав Исполнителя: использование кабинета,
          загрузка прайсов, формирование заявок и иные функции по тарифу. Исходный код ПО не передаётся.
          Территория — Российская Федерация.
        </p>

        <h2>4. Правовой статус ПО</h2>
        <ul>
          <li>
            Исключительное право на программу для ЭВМ «Провизиум» принадлежит Загумённову Д.Н.
            (правообладатель / Лицензиар).
          </li>
          <li>
            Исполнитель предоставляет доступ на основании исключительной лицензии, полученной от
            правообладателя (в т.ч. п. 7.2.4 лицензионного договора Лицензиар ↔ Лицензиат).
          </li>
          <li>
            Бренд «Провизиум» / «Provisium» используется как коммерческое обозначение / бренд сервиса.
            Товарный знак на дату настоящей редакции не заявляется.
          </li>
        </ul>

        <h2>5. Акцепт</h2>
        <p>
          Акцепт оферты — регистрация учётной записи с отметкой согласия с офертой и (или) оплата тарифа.
          Без принятия оферты self-serve регистрация не завершается.
        </p>

        <h2>6. Тарифы и пробный доступ</h2>
        <ul>
          <li>
            <strong>Старт</strong> — 0 ₽: до 3 поставщиков в «Моих прайсах», обновление прайса 1 раз в 10
            дней, 1 пользователь, 1 заведение. После регистрации — сразу кабинет без оплаты.
          </li>
          <li>
            <strong>Месяц</strong> — 2 990 ₽/мес: без лимитов Старта на поставщиков и обновления; команда до 3;
            1 заведение, каждое доп. — +1 990 ₽/мес.
          </li>
          <li>
            <strong>Год</strong> — 29 900 ₽/год: условия Месяца, сразу 2 заведения без доплаты, фиксация цены
            на 12 месяцев.
          </li>
          <li>
            Новым аккаунтам при регистрации на тарифе «Старт» — 1 месяц полного доступа (как
            «Месяц») один раз на аккаунт. После окончания без оплаты — тариф «Старт». Регистрация на
            «Месяц»/«Год» ведёт к оформлению оплаты.
          </li>
        </ul>
        <p>Оплата — фиксированная подписка, без комиссии с закупок. НДС — по фактическому режиму Исполнителя (УСН без НДС, если применимо; уточняется в счёте).</p>

        <h2>7. Оплата и счета</h2>
        <p>
          Онлайн-оплата картой подключается по мере выбора платёжного провайдера. Для тарифа «Год» и B2B по
          запросу — счёт на оплату. Банк: р/с 40802810329190006030, Филиал «Нижегородский» АО «Альфа-Банк»,
          г. Нижний Новгород, к/с 30101810200000000824, БИК 042202824.
        </p>

        <h2>8. Данные организации и реклама</h2>
        <p>
          Исполнитель обрабатывает данные юридического лица (ИНН, юридическое и торговое название,
          корпоративная почта) по{' '}
          <a href={PRIVACY_POLICY_EXTERNAL_URL} target="_blank" rel="noreferrer">
            Политике конфиденциальности
          </a>
          . Рекламные сообщения на корпоративную почту — только при отдельном{' '}
          <a href={MARKETING_CONSENT_EXTERNAL_URL} target="_blank" rel="noreferrer">
            согласии
          </a>
          .
        </p>

        <h2>9. Ограничения использования</h2>
        <p>
          Запрещены реверс-инжиниринг, передача доступа третьим лицам вне тарифа, обход технических
          ограничений. Исполнитель вправе ограничить доступ при нарушении оферты или неоплате.
        </p>

        <h2>10. Изменение оферты</h2>
        <p>
          Новая редакция публикуется на {PUBLIC_OFFER_EXTERNAL_URL} с датой вступления. Продолжение
          использования после даты может означать согласие с новой редакцией, если иное не требуется
          законом.
        </p>

        <h2>11. Реквизиты Исполнителя</h2>
        <p>
          ИП Новоселов Федор Владимирович · ИНН 110119365449 · ОГРНИП 318112100016230 · 614095, г. Пермь,
          ул. Карпинского, д. 65, кв. 228 · support@provisium.ru
        </p>
      </div>

      <p className="market-legal-doc__back">
        <Link className="market-auth__signup-link" to="/register">
          ← Вернуться к регистрации
        </Link>
      </p>
    </article>
  </AuthScreenLayout>
)
